module.exports = __webpack_public_path__ + "static/media/Banee's-Academy-Logo.b703e3d8.webp";